// extracted by mini-css-extract-plugin
export var accessoire = "style-mod--accessoire--8d8fa";
export var accessoireImg = "style-mod--accessoire-img--43aca";
export var accessoireImgContainer = "style-mod--accessoire-img-container--d55c5";
export var accessoireImgWrap = "style-mod--accessoire-img-wrap--89e65";
export var accessoireSet = "style-mod--accessoire-set--1bb7b";
export var accessoireText = "style-mod--accessoire-text--b312e";
export var accessoireTextContainer = "style-mod--accessoire-text-container--26480";
export var accessoiresList = "style-mod--accessoires-list--b211f";
export var accessoiresListSet = "style-mod--accessoires-list-set--6adcd";
export var accessoiresListText = "style-mod--accessoires-list-text--32b9b";
export var accessoiresSelected = "style-mod--accessoires-selected--0f794";
export var setTextContainer = "style-mod--set-text-container--fab65";
export var textContainer = "style-mod--text-container--39db7";
export var variantDescription = "style-mod--variant-description--5ede5";
export var variantText = "style-mod--variant-text--28587";